import { Logo } from '@repo/ui/components/logo'
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@repo/ui/components/ui/sidebar'
import { Link } from '@tanstack/react-router'

export function AppLogo() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          size="lg"
          asChild
          className="rounded-[4px] data-[state=open]:bg-sidebar-accent/70"
        >
          <Link
            to="/"
            className="app-premium-panel app-premium-panel-lift rounded-[4px] border-sidebar-border/70 py-2"
          >
            <div className="app-icon-tile aspect-square size-8 bg-primary text-primary-foreground">
              <Logo className="size-4" />
            </div>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-semibold tracking-tight">Zippity</span>
              <span className="truncate text-[11px] text-muted-foreground">Route-aware booking</span>
            </div>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
